var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{staticClass:"text-left",attrs:{"id":_vm.modalId,"title":"Edit GL Code"},on:{"on-hide":_vm.resetFormData}},[_c('gl-code-form',_vm._b({key:_vm.formKey,on:{"on-submit":_vm.updateGlCode,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'gl-code-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }